import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Thread } from '../../types/thread';
import { formatDateTime } from '../../utils/contractHelpers';

interface ThreadListProps {
    threads: Thread[];
    activeThreadId?: string;
    onSelect: (threadId: string) => void;
    currentUserId: string;
}

export const ThreadList: React.FC<ThreadListProps> = ({ threads, activeThreadId, onSelect, currentUserId }) => {
    const navigate = useNavigate();
    const getLastMessagePreview = (thread: Thread) => {
        if (!thread.lastMessage) {
            return '暂无消息';
        }

        if (thread.lastMessage.type === 'TEXT' || thread.lastMessage.type === 'SYSTEM') {
            return thread.lastMessage.content;
        }

        if (thread.lastMessage.type === 'TRIAL_REQUEST') {
            return '试稿请求';
        }

        if (thread.lastMessage.type === 'PROPOSAL') {
            return '[合作方案]';
        }

        if (thread.lastMessage.type === 'INVITATION') {
            return '[合作邀请]';
        }

        return thread.lastMessage.content;
    };

    return (
        <div className="h-full overflow-y-auto">
            {threads.map(thread => {
                const partner = thread.participants.find(p => p.userId !== currentUserId) || thread.participants[0];
                const isActive = thread.id === activeThreadId;

                return (
                    <div
                        key={thread.id}
                        onClick={() => onSelect(thread.id)}
                        className={`p-4 border-b border-gray-50 cursor-pointer transition-colors hover:bg-gray-50 ${isActive ? 'bg-blue-50/50 border-r-2 border-r-blue-500' : ''}`}
                    >
                        <div className="flex items-center gap-3">
                            <div className="relative">
                                {partner.userId === 'system' ? (
                                    <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                                        <span className="text-lg">📢</span>
                                    </div>
                                ) : (
                                    <img
                                        src={partner.avatar}
                                        alt={partner.nickname}
                                        className="w-10 h-10 rounded-full object-cover border border-gray-100 cursor-pointer hover:opacity-80 transition-opacity"
                                        onClick={(e) => { e.stopPropagation(); navigate(`/profile/${partner.userId}`); }}
                                    />
                                )}
                                {thread.unreadCount > 0 && (
                                    <div className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 rounded-full border-2 border-white"></div>
                                )}
                            </div>
                            <div className="flex-1 min-w-0">
                                <div className="flex justify-between items-start mb-0.5">
                                    <h4
                                        className={`font-bold text-sm truncate ${partner.userId === 'system' ? '' : 'cursor-pointer hover:opacity-80 transition-opacity'} ${isActive ? 'text-blue-900' : 'text-gray-900'}`}
                                        onClick={partner.userId === 'system' ? undefined : (e) => { e.stopPropagation(); navigate(`/profile/${partner.userId}`); }}
                                    >
                                        {partner.nickname}
                                    </h4>
                                    <span className="text-xs text-gray-400 whitespace-nowrap">
                                        {thread.lastMessage && thread.lastMessage.createdAt > 0 ? formatDateTime(thread.lastMessage.createdAt).split(' ')[0] : ''}
                                    </span>
                                </div>
                                <p className={`text-xs truncate ${thread.unreadCount > 0 ? 'font-bold text-gray-800' : 'text-gray-500'}`}>
                                    {getLastMessagePreview(thread)}
                                </p>
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};
